<script>
import Vue from 'vue';
import { WithBreakpointComponent } from './breakpoints';
import { mapGetters } from 'vuex';

export default {
    mixins: [WithBreakpointComponent],
    props: {
        tabInit: {
            type: String,
            default: 'new-homes'
        },
        usesMobilePopover: {
            type: Boolean,
            default: false
        }
    },
    data: () => ({
        tab: 'new-homes',
        mapToggle: 'map',
        newHomeCommunities: [],
        rentalCommunities: [],
    }),
    watch: {
        tab(val) {
            this.$eventsBus.$emit('where-we-build-tabbed', val);
            this.changeUrlPath();
        }
    },
    computed: {
        ...mapGetters({appData: 'app/getData'}),
        showList() {
            const isTablet = this.currentBreakpoint === 'tablet';
            const isPhone = this.currentBreakpoint === 'phone';
            return (!isTablet && !isPhone) ? true : this.mapToggle === 'list';
        },
        showMap() {
            const isTablet = this.currentBreakpoint === 'tablet';
            const isPhone = this.currentBreakpoint === 'phone';
            return (!isTablet && !isPhone) ? true : this.mapToggle === 'map';
        }
    },
    created() {
        this.tab = this.tabInit;
    },
    methods: {
        changeUrlPath() {
            let url = window.location.origin;
            let title = '';
            if (this.tab === 'new-homes') {
                url += '/new-home-communities';
                title = 'New Home Communities';
            } else if (this.tab === 'rental') {
                url += '/rental-communities';
                title = 'Rental Communities';
            }
            history.pushState({}, title, url);
        }
    }
};
</script>
